import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ApiError } from "../api/client.js";
import { useLogin } from "../api/hooks.js";

export function LoginPage() {
  const login = useLogin();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mfaCode, setMfaCode] = useState("");
  const mfaNeeded = login.data?.mfa_required === true;

  return (
    <form
      className="stack login-card"
      onSubmit={(e) => {
        e.preventDefault();
        if (mfaNeeded) {
          // MFA verification is a second-step mutation handled by the API session.
          void fetch("/api/v1/auth/mfa/verify", {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code: mfaCode }),
          });
          navigate("/");
          return;
        }
        login.mutate({ email, password });
      }}
    >
      <div className="brand-mark">Q</div>
      <p className="eyebrow">QUESTGUARDIAN</p>
      <h2>
        More balance.
        <br />
        Better adventures.
      </h2>
      <p className="muted">Sign in to manage your household’s playtime.</p>
      {login.error ? (
        <p className="notice danger">
          {login.error instanceof ApiError
            ? `${login.error.code}: ${login.error.message}`
            : "login failed"}
        </p>
      ) : null}
      <label htmlFor="email">Email</label>
      <input
        id="email"
        autoComplete="username"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <label htmlFor="password">Password</label>
      <input
        id="password"
        autoComplete="current-password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        minLength={8}
        required
      />
      {mfaNeeded ? (
        <>
          <label htmlFor="mfa">6-digit MFA code</label>
          <input
            id="mfa"
            inputMode="numeric"
            pattern="[0-9]{6}"
            value={mfaCode}
            onChange={(e) => setMfaCode(e.target.value)}
            required
          />
        </>
      ) : null}
      <button type="submit" disabled={login.isPending}>
        {login.isPending ? "Signing in…" : mfaNeeded ? "Verify" : "Sign in"}
      </button>
    </form>
  );
}
